import * as algolia from '@boutique/algolia'
import * as cold from '@owl-nest/cold-data/client'
import * as entities from '@boutique/entities'

import * as base from './base'

export async function searchGiftIdea({
  facetFilters,
  sort,
  page,
  hitsPerPage,
  priceRange,
  showHidden,
  filters,
}: entities.search.giftIdea.Query): Promise<entities.search.giftIdea.Result> {
  const simpleFilters: (string | string[])[] = ['availableForSale:true', 'tags:idkdo']
  if (!showHidden) {
    simpleFilters.push('NOT tags:hidden')
  }
  if (filters) {
    simpleFilters.push(...filters)
  }

  const facets = base.facets<entities.search.giftIdea.Filters>(facetFilters, entities.search.giftIdea.FILTERS, {
    category: (value) => {
      if (value === 'all') {
        return []
      }
      // some categories does not exists, so they are replaced with a collection
      // of tags
      if (value in FAKE_CATEGORIES) {
        return [{ value: (FAKE_CATEGORIES as any)[value] }]
      }

      return [{ value }]
    },
    person: (value) => {
      if (cold.taxonomies['genre'].children.tags.includes(value)) {
        return [{ value }]
      }

      if (value === 'enfant' || value === 'puericulture' || value === 'animaux') {
        return [{ value }]
      }

      if (value === 'all') {
        return [{ value: 'unisexe' }]
      }

      return []
    },
    criterion: (value) => {
      if (
        cold.taxonomies['pilier-environnemental'].children.tags.includes(value) ||
        cold.taxonomies['pilier-social'].children.tags.includes(value)
      ) {
        return [{ value }]
      }

      return []
    },
  })

  const response = await algolia.product.search({
    sortIndex: sort,
    filters: simpleFilters,
    priceRange,
    page,
    hitsPerPage,
    facets,
  })

  return base.toSearchResult(response, facets, entities.search.giftIdea.FILTERS)
}

export const FAKE_CATEGORIES = {
  alimentation: [
    'alimentation',
    'lunch-box',
    'moules',
    'tabliers',
    'cuisson',
    'arts-de-la-table',
    'emballages-beeswrap-pinces-a-sachet',
    'ustensiles',
  ],
  'livres-et-papeterie': ['livres-enfants', 'livres', 'magazines', 'bd-manga-comics'],
  maison: [
    'decorations',
    'linges-de-maison-et-tapis',
    'linges-de-lit',
    'linges-de-table',
    'serviettes-de-table',
    'linges-de-bain',
    'tapis',
    'paillassons',
    'couvertures-et-couvre-lit',
    'coussins',
    'arts-de-la-table',
    'ustensiles',
    'vaisselles',
    'bocaux-et-flacons',
    'carafes-deau-et-filtres-a-eau',
    'paniers',
    'boites-de-rangement',
    'sac-a-savon',
    'porte-savon',
    'bougie-parfum-dambiance',
    'canape-et-fauteil',
    'table-et-bureau',
    'meuble-de-salle-de-bain',
    'meuble-de-cuisine',
    'etagere',
    'decorations-murales-et-miroirs',
    'veilleuses',
    'tipis',
    'lampes-et-luminaires',
    'objets-decoratifs',
    'vases',
    'nappes-et-toiles-cirees',
    'chaises-et-tabourets',
    'rideaux-et-voilages',
    'brocs-et-cruches',
    'tables-de-chevet',
    'tapis-de-bain',
    'mobilier-decoration-exterieur',
    'dessous-de-plat',
    'torchons-et-gants-de-cuisine',
    'porte-manteaux-et-pateres',
    'affiches',
    'horloges',
  ],
}
